
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reklama-v-zhilyh-domah",
      function () {
        return require("private-next-pages/reklama-v-zhilyh-domah/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reklama-v-zhilyh-domah"])
      });
    }
  